import { apiSlice } from "../api/apiSlice";

export const leaderboardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => ({
        url: "users/?role=student",
        method: "GET",
      }),
    }),
    getAssignmentMark: builder.query({
      query: () => ({
        url: "assignmentMark",
        method: "GET",
      }),
    }),
    getQuizMark: builder.query({
      query: () => ({
        url: "quizMark",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetAssignmentMarkQuery,
  useGetQuizMarkQuery,
} = leaderboardApi;
